import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// ----- Cart drawer upsell loader -----
function loadCartUpsell() {
  const container = document.querySelector('[data-cart-upsell]');
  if (!container) return;
  if (container.dataset.loaded === 'true') return;

  fetch('/sections/cart-upsell')
    .then((response) => {
      if (!response.ok) throw new Error('Upsell section fetch failed');
      return response.text();
    })
    .then((html) => {
      if (!html || !html.trim()) return;
      container.innerHTML = html;
      container.dataset.loaded = 'true';
    })
    .catch((error) => {
      console.warn('Cart upsell error:', error);
    });
}

// Run on initial load
document.addEventListener('DOMContentLoaded', loadCartUpsell);

// Run again if Shopify re-renders sections (Theme Editor / AJAX reloads)
document.addEventListener('shopify:section:load', loadCartUpsell);
